import _findIndex from 'lodash/findIndex'

import {
    RECEIVE_TAX_REGISTRATION_REASONS,
    REMOVE_TAX_REGISTRATION_REASON,
    REQUEST_TAX_REGISTRATION_REASONS,
} from '../actions'
import { removeItemsById } from '../helpers'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: null,
        items: [],
    },
    actions
) => {
    const { type, data } = actions

    switch (type) {
        case REQUEST_TAX_REGISTRATION_REASONS:
            return { ...state, isFetching: true }

        case RECEIVE_TAX_REGISTRATION_REASONS: {
            const { items: currentItems } = state
            const { items: receivedItems } = data

            const items = Object.assign([], currentItems)

            if (Array.isArray(receivedItems)) {
                receivedItems.forEach((item) => {
                    const key = _findIndex(items, ['reason', item.reason])

                    if (key > -1 && items[key]) {
                        items[key] = item
                    } else {
                        items.push(item)
                    }
                })
            }

            return { ...state, ...data, items, isFetching: false }
        }

        case REMOVE_TAX_REGISTRATION_REASON: {
            const items = removeItemsById({ currentItems: state.items, id: data.id })
            return { ...state, ...data, items }
        }

        default:
            return state
    }
}
